export const subjectPropertyTypeWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  marginBottom: '24px',
};

export const subjectPropertyTypeLabelStyles = {
  color: ({ palette }) => palette.text.secondary,
};
